import * as uri from '../config/uri';
import * as QueryParams from '../const/query_params';
import { getQueryParameters } from '../services/uri';

export const getItemUrlBySuggestionType = (item, type, customerType) => {
  let url = `${uri.getSearchUri()}${encodeURI(`?${QueryParams.QUERY}=${item.name}&${QueryParams.SEARCH_TYPE}=${type}&${QueryParams.CUSTOMER_TYPE}=${customerType}`)}`
    
  if (type === 'product') {
    url += encodeURI(`&productId=${item.productId}`)
  } 

  return url;
}

export const getSearchQueryUrl = (searchString) => {
  return `${uri.getSearchUri()}${encodeURI(`${getQueryParameters()}&${QueryParams.QUERY}=${searchString}`)}`;
};

export const getCollectionSearchQueryUrl = (collectionId) => {
  return `${uri.getSearchUri()}${encodeURI(`${getQueryParameters()}&${QueryParams.COLLECTIONS}=${collectionId}`)}`;
};

export const getTypeName = (item, type) => {
  return type === 'product' || type === 'edible' ? item.type : type;
}

export const getIconName = (item, type) => {
  return type === 'product' || type === 'type' ? item.type : type;
}

export const isAnyOptions = (results) => {

  return Object.keys(results).reduce((acc, key) => {
    if (results[key] && results[key].length > 0) {
      acc += 1;
    }
    return acc;
  }, 0) > 0;
}


// WEBPACK FOOTER //
// ./src/helpers/searchBarHelper.js